// for customer signup with google
export const RESET_GOOGLE_SIGNUP = "reset_google_signup";
export const GOOGLE_SIGNUP = "google_signup";
export const GOOGLE_SIGNUP_SUCCESS = "google_signup_success";
export const GOOGLE_SIGNUP_FAILURE = "google_signup_failure";
